import { clearSession, session } from "./session";
import type { ApiResult } from "./protocol";
import { apiUrl } from "./endpoints";

export async function request<T>(path: string, body?: object): Promise<T> {
  const token = session.token;
  const response = await fetch(apiUrl(path), {
    method: body ? "POST" : "GET",
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
    signal: AbortSignal.timeout(60000),
  });
  if (!response.ok) throw new Error(`请求失败 (${response.status})`);
  const result: ApiResult<T> = await response.json();
  if (result.type !== "success") {
    if (token && ["未登录", "身份已失效", "登录已失效"].includes(result.message || "")) clearSession(token);
    throw new Error(result.message || "操作失败");
  }
  return result.data;
}
